import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

export enum TooltipPositions {
    left = 'left',
    right = 'right',
    above = 'above',
    below = 'below',
    before = 'before',
    after = 'after'
}

export class ConfigData {

    public static tooltipConfiguration: MatTooltipDefaultOptions = {
        showDelay: 500,
        hideDelay: 0,
        touchendHideDelay: 0,
        position: TooltipPositions.below
    };


}



